module.exports = __webpack_public_path__ + "img/mtzyicon@2X.07fb288c.png";